import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BookingWalkthrough from './BookingWalkthrough';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Footer from './Footer';

const BookNowPage = () => {
  const navigate = useNavigate();

  // Meta Pixel ViewContent tracking for Book Now page
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: 'Book Now Page - Pro-Wash Mobile Detailing',
        content_category: 'Mobile Car Detailing Booking',
        value: 299,
        currency: 'CAD'
      });
    }
  }, []);

  const handleBackHome = () => {
    navigate('/');
  };

  return (
    <div>
      {/* Hidden SEO content - invisible but crawlable */}
      <div className="sr-only">
        <h1>Book Your Detail</h1>
        <p>Premium mobile car detailing in Abbotsford, BC</p>
      </div>

      {/* All homepage sections except Hero */}
      <BookingWalkthrough />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
};

export default BookNowPage;